import { linkStore } from "../common-behaviors/link.store";
import { scriptStore } from "../common-behaviors/script.store";

export class ResourcesService {
  public static loadDependences(company: any) {
    ResourcesService.loadLinks();
    ResourcesService.loadScripts(company);
  }

  private static loadScripts(company) {
    scriptStore.forEach((script: any) => {
      if (script.name === "sportsbook") {
        script.enabled = company?.sb_iframe?.enable;
      }
      if (script.enabled) {
        this.loadScriptTag(script.src, script.asyncFlag).catch((error) => console.error(error));
      }
    });
  }

  private static loadLinks() {
    for (const link of linkStore.filter((link) => link.enabled)) {
      this.loadLinkTag(link.url, link.rel, link.attributes).catch((error) => console.error(error));
    }
  }

  public static loadLinkTag(url: string, rel: string = "stylesheet", attributes: Record<string, string> = {}): Promise<HTMLLinkElement> {
    return new Promise((resolve, reject) => {
      // Prevent duplicate links by checking if one already exists.
      if (document.querySelector(`link[href="${url}"]`)) {
        console.warn(`Link tag with href "${url}" already exists.`);
        resolve(document.querySelector(`link[href="${url}"]`) as HTMLLinkElement);
        return;
      }

      const linkTag: HTMLLinkElement = document.createElement("link");
      linkTag.rel = rel;
      linkTag.href = url;

      // Set additional attributes, if provided.
      Object.keys(attributes).forEach((key) => {
        linkTag.setAttribute(key, attributes[key]);
      });

      // Listen for load and error events.
      linkTag.onload = () => {
        // console.info(`Successfully loaded <link rel="${rel}" href="${url}">`);
        resolve(linkTag);
      };

      linkTag.onerror = (ev) => {
        console.error(`Error loading <link rel="${rel}" href="${url}">`, ev);
        reject(new Error(`Failed to load ${url}`));
      };

      document.head.appendChild(linkTag);
    });
  }

  public static loadScriptTag(src: string, asyncFlag: boolean = true): Promise<HTMLScriptElement> {
    return new Promise((resolve, reject) => {
      // Prevent duplicate scripts by checking if one already exists.
      if (document.querySelector(`script[src="${src}"]`)) {
        console.warn(`Script with src "${src}" already exists.`);
        resolve(document.querySelector(`script[src="${src}"]`) as HTMLScriptElement);
        return;
      }

      const scriptTag: HTMLScriptElement = document.createElement("script");
      scriptTag.src = src;
      scriptTag.async = asyncFlag;

      // Listen for load and error events.
      scriptTag.onload = () => {
        // console.info(`Successfully loaded script: ${src}`);
        resolve(scriptTag);
      };

      scriptTag.onerror = (ev) => {
        console.error(`Error loading script: ${src}`, ev);
        reject(new Error(`Failed to load script: ${src}`));
      };

      // Append the script tag to the end of the document body.
      document.body.appendChild(scriptTag);
    });
  }
}
